export default "__VITE_ASSET__0d2e6caa__"